module.exports = __webpack_public_path__ + "media/images/default_image-05285446f2f638ee235a80bf2f12b7a4.png";